import { render, staticRenderFns } from "./TrademarkModel.vue?vue&type=template&id=4554afa0"
import script from "./TrademarkModel.vue?vue&type=script&lang=js"
export * from "./TrademarkModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports